import Styles from './FinalStep.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { TopBar } from '../TopBar/TopBar'
import { LoadingState } from 'components/FirstTimeExperienceModal/steps/CampaignGeneration/LoadingState'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

export const FinalStep = ({ finishedLoading }: { finishedLoading: boolean }) => {
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return (
      <div className={Styles.mobileContainer}>
        <img
          className={Styles.mobileIllustration}
          alt="blaze illustration"
          src="https://res.cloudinary.com/almanac/image/upload/v1773750455/blaze_assets/virtual_marketer/onboarding/Frame_1171277093_i0xtxn.png"
        />
        <div className={Styles.mobileContent}>
          <Heading level={4} color="var(--dark-60)">
            🎉 Now, the fun part!
          </Heading>
          <Heading level={1}>
            Let’s generate your first week of content for all your channels
            <LoadingEllipses />
          </Heading>
        </div>
      </div>
    )
  }
  return (
    <div className={Styles.container}>
      <TopBar highlightStep="finishingUp" />
      <div className={Styles.leftSide}>
        <div className={Styles.leftContent}>
          <div className={Styles.texts}>
            <Heading level={4} color="var(--dark-60)">
              🎉 Now, the fun part!
            </Heading>
            <Heading level={1}>Let's generate your first week of content.</Heading>
          </div>
          <LoadingState finishedLoading={finishedLoading} />
        </div>
      </div>
      <img
        className={Styles.blazeIllustration}
        alt="blaze illustration"
        src="https://res.cloudinary.com/almanac/image/upload/v1772131541/blaze_assets/virtual_marketer/onboarding/Frame_1171276883_nlqa30.png"
      />
    </div>
  )
}
